module.exports = __webpack_public_path__ + "img/old4.b1fbba16.jpg";